'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var ConsumableBuffer = require('./consumable-buffer');

module.exports = function wrapHash(hashFn) {
  return function hashing(value) {
    if (value instanceof InfiniteHash) {
      // already a hash. return it
      return value;
    } else {
      return new InfiniteHash(value, hashFn);
    }
  };
};

var InfiniteHash =
/*#__PURE__*/
function () {
  function InfiniteHash(value, hashFn) {
    _classCallCheck(this, InfiniteHash);

    if (typeof value !== 'string' && !Buffer.isBuffer(value)) {
      throw new Error('can only hash strings or buffers');
    }

    this._value = value;
    this._hashFn = hashFn;
    this._depth = -1;
    this._availableBits = 0;
    this._currentBufferIndex = 0;
    this._buffers = [];
  }

  _createClass(InfiniteHash, [{
    key: "take",
    value: function take(bits) {
      var pendingBits, result, hash, available, took;
      return _regeneratorRuntime.async(function take$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pendingBits = bits;

            case 1:
              if (!(this._availableBits < pendingBits)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _regeneratorRuntime.awrap(this._produceMoreBits());

            case 4:
              _context.next = 1;
              break;

            case 6:
              result = 0;

              while (pendingBits > 0) {
                hash = this._buffers[this._currentBufferIndex];
                available = Math.min(hash.availableBits(), pendingBits);
                took = hash.take(available);
                result = (result << available) + took;
                pendingBits -= available;
                this._availableBits -= available;

                if (hash.availableBits() === 0) {
                  this._currentBufferIndex++;
                }
              }

              return _context.abrupt("return", result);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "untake",
    value: function untake(bits) {
      var pendingBits = bits;

      while (pendingBits > 0) {
        var hash = this._buffers[this._currentBufferIndex];
        var availableForUntake = Math.min(hash.totalBits() - hash.availableBits(), pendingBits);
        hash.untake(availableForUntake);
        pendingBits -= availableForUntake;
        this._availableBits += availableForUntake;

        if (this._currentBufferIndex > 0 && hash.totalBits() === hash.availableBits()) {
          this._depth--;
          this._currentBufferIndex--;
        }
      }
    }
  }, {
    key: "_produceMoreBits",
    value: function _produceMoreBits() {
      var value, hashValue, buffer;
      return _regeneratorRuntime.async(function _produceMoreBits$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this._depth++;
              value = this._depth ? this._value + this._depth : this._value;
              _context2.next = 4;
              return _regeneratorRuntime.awrap(this._hashFn(value));

            case 4:
              hashValue = _context2.sent;
              buffer = new ConsumableBuffer(hashValue);

              this._buffers.push(buffer);

              this._availableBits += buffer.availableBits();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }]);

  return InfiniteHash;
}();